$( document ).ready(function() {
	
	// Animated section jump
	$('.calendar-tour a[href^="#"]').bind('click.smoothscroll',function (e) {
	    e.preventDefault();
	    var target = this.hash,
	    $target = $(target);
	    $('html, body').stop().animate({
	          'scrollTop': $target.offset().top
	      }, 600, 'swing', function () {
	          window.location.hash = target;
	    });
	});
	
	
	// Initialize Slider
	$('.calendar-ugc-slider').slick({
		initialSlide: 0,
		dots: true,
		infinite: true,
		speed: 300,
		slidesToShow: 3,
		centerMode: true,
		centerPadding: '80px',
		arrows: true,
		responsive: [
		    {
				breakpoint: 768,
				settings: {
					dots: true,
			        arrows: true,
			        centerMode: true,
			        centerPadding: '40px',
			        slidesToShow: 3
				}
		    },
		    {
		      breakpoint: 480,
		      settings: {
					arrows: false,
					centerMode: true,
					centerPadding: '60px',
					slidesToShow: 1
				}
		    }
		]
	});
	
	$('.calendar-ugc-slider').slick("slickGoTo",1,true);
	$('.calendar-ugc-slider').slick("slickGoTo",0,true);

});